<template>
  <v-container class="container--fluid cookie-policy-wrap">
    <v-row justify="center">
      <v-col cols="12" lg="8">
        <p>
          Este site utiliza cookies para coletar informações sobre como os
          nossos visitantes usam nosso site. Estas informações nos ajudam a
          proporcionar a você a melhor experiência possível, personalizar o
          conteúdo que oferecemos e apresentar ofertas adequadas aos seus
          interesses. Para mais informações sobre o uso que fazemos dos cookies,
          acesse a nossa
          <a
            title="Política de Privacidade"
            href="/politica-de-privacidade"
            target="_self"
            class="read-more"
            >Política de Privacidade</a
          >
        </p>
      </v-col>
      <v-col cols="12" lg="2">
        <a class="accept-btn" @click="addCookie">OK, ENTENDI.</a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PopupCookiePolicy',
  data() {
    return {
      dialog: false,
      result: null,
    };
  },
  mounted() {
    if (this.$cookies.isKey('eureciclo-default')) {
      document.querySelector('.cookie-policy-wrap').classList.add('hide');
    }
  },
  methods: {
    addCookie() {
      const date = new Date().getTime() / 1000;
      this.$cookies.set('eureciclo-default', date, '30d');
      document.querySelector('.cookie-policy-wrap').classList.add('hide');
    },
  },
};
</script>
<style lang="sass" scoped>
.cookie-policy-wrap
  background: #f5f5f5
  position: fixed
  z-index: 999999999
  left: 0
  bottom: 0
  right: 0
  width: 100%
  padding: 13px 15px
  display: block
  transition: all 0.3s
  box-sizing: border-box
  &.hide
    transform: translateY(100%)
  p,
  .accept-btn,
  .read-more
    font-style: normal
    font-weight: normal
    font-size: 12px
    line-height: 14px
    letter-spacing: 0.05em
    color: #2b2b2b
    margin: 0
  .read-more
    text-decoration: underline
    font-weight: 700
    transition: all 300ms ease-in-out
    &:hover
      color: #9ba2a8
      transition: all 300ms ease-in-out
  .accept-btn
    display: block
    text-align: center
    font-size: 14px
    line-height: 17px
    letter-spacing: 0.03em
    color: #2b2b2b
    text-transform: uppercase
    border: 1px solid #2b2b2b
    padding: 5px 26px
    background: transparent
    border-radius: 5px
    transition: all 0.3s ease-in-out
    &:hover
      background: #2b2b2b
      color: #ffffff
      transition: all 0.3s ease-in-out
</style>
